module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-rating-content-theme.f9b7e623.svg";